import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router'
import { LazyMotion, MotionConfig } from 'motion/react'
import './index.css'
import App from '@/app/App'
import { AuthGate } from '@/app/AuthGate'

// Query config mirrors the lead-gen platform the CRM was extracted from.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 1 minute
      retry: 1,
      // The lead list is the app's largest response; React Query's default
      // would refire it on every tab return past the stale window.
      refetchOnWindowFocus: false,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* Features load as their own chunk: importing `domAnimation` directly
          would bundle it into the main entry and defeat the point. Covers
          enter/exit and variants, not layout or drag. `strict` makes importing
          the full `motion` component a build error, so it stays that way.
          `reducedMotion="user"` applies the OS setting to everything below
          without each animation re-checking. */}
      <LazyMotion features={() => import('./motion-features').then(mod => mod.default)} strict>
        <MotionConfig reducedMotion="user">
          <BrowserRouter>
            <AuthGate>
              <App />
            </AuthGate>
          </BrowserRouter>
        </MotionConfig>
      </LazyMotion>
    </QueryClientProvider>
  </StrictMode>,
)
